import styled from 'styled-components';
import { beam } from '@styles/colors/themes';

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
`;
export const ContainerSidebar = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: relative;
  border: 1px solid #d8dae5;
  border-radius: 8px;
  height: 42px;
  width: 42px;
  background-color: transparent;
`;
interface IIcon {
  width: number;
}
export const Block = styled.div<IIcon>`
  background: #fff;
  border-radius: 8px;
  position: absolute;
  top: 48px;
  right: 37px;
  width: 190px;
  z-index: 10;
  cursor: auto;
`;
export const CircleDiv = styled.div`
  display: flex;
  position: absolute;
  justify-content: center;
  align-items: center;
  color: ${beam.color.pureWhite};
  background: ${beam.color.primaryBlue};

  border-radius: 50%;
  -webkit-box-pack: center;
  -webkit-box-align: center;
  font-size: 10px;
  font-weight: 700;
  right: -5px;
  bottom: -5px;
  width: 14px;
  height: 14px;
`;

export const Icon = styled.div<IIcon>`
  min-width: ${({ width }) => width}px;
  width: ${({ width }) => width}px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const RoleButton = styled.button`
  display: flex;
  flex-direction: row;
  width: 100%;
  background-color: transparent;
  border: 0;
  cursor: pointer;
`;

export const RoleInput = styled.input`
  width: 100%;
  height: 42px;
  padding: 10px 12px;
  border: 1px solid #d8dae5;
  border-radius: 8px;
  cursor: pointer;

  font-size: 14px;
  font-weight: 400;
  color: #474d66;

  ::placeholder {
    color: #8f95b2;
  }

  :disabled {
    background-color: transparent;
  }
`;

export const IconWrapper = styled.div`
  display: flex;
  padding-top: 12px;
  margin-left: -30px;
`;
